export interface ISearchFilter {
  formControlName: string;
  label: string;
  value?: string | number | boolean;
}

export class SearchFilter implements ISearchFilter {
  formControlName: string;
  label: string;
  value?: string | number | boolean;

  constructor();
  constructor(obj: ISearchFilter);
  constructor(obj?: ISearchFilter) {
    this.formControlName = obj?.formControlName ?? '';
    this.label = obj?.label ?? '';
    if (obj?.value) this.value = obj?.value;
  }
}
